import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";
export interface State {
    id:number;
    name:string;
    description?:string;
    existing_llc?:number;
    status?:number;
    type?:string;
}
export const stateApi = createApi({
    reducerPath: "stateApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getStates: builder.query<State[], void>({
            query: () => "/state"
        })
    })
})

export const {useGetStatesQuery} = stateApi;